import { createStore, createActionsHook, createStateHook, createHook } from 'react-sweet-state';

const ContentHistoryStore = createStore({
	initialState: {
		shouldShowNewContentHistory: false,
		wasTransitionedFromEditor: false,
	},
	actions: {
		showNewContentHistory:
			() =>
			({ setState }) => {
				setState({
					shouldShowNewContentHistory: true,
				});
			},
		hideNewContentHistory:
			() =>
			({ setState }) => {
				setState({
					shouldShowNewContentHistory: false,
				});
			},
		setWasTransitionedFromEditor:
			(wasTransitionedFromEditor: boolean) =>
			({ setState }) => {
				setState({
					wasTransitionedFromEditor,
				});
			},
	},
	name: 'newContentHistoryState',
});

export const useNewContentHistoryState = createStateHook(ContentHistoryStore);
export const useNewContentHistoryActions = createActionsHook(ContentHistoryStore);
export const useNewContentHistory = createHook(ContentHistoryStore);
